"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _reshowConstant = require("reshow-constant");
//@ts-check

/**
 * @typedef {{obj?: any, prev?: any, next?: any, nextIndex?: string | number, path?: any[] }} DefaultValueOption
 */
/**
 * @param {any} v
 * @param {DefaultValueOption} [options]
 * @returns {any}
 */
var getDefaultValue = function getDefaultValue(v, options) {
  var _options;
  if (options === void 0) {
    options = {
      obj: _reshowConstant.T_UNDEFINED,
      prev: _reshowConstant.T_UNDEFINED,
      next: _reshowConstant.T_UNDEFINED,
      nextIndex: _reshowConstant.T_UNDEFINED,
      path: []
    };
  }
  return _reshowConstant.FUNCTION === typeof v ? v(options) : v !== null && v !== void 0 ? v : (_options = options) === null || _options === void 0 ? void 0 : _options.next;
};
var _default = exports["default"] = getDefaultValue;
module.exports = exports.default;